/* eslint-disable react/no-array-index-key */
import type { IStyler } from '@alfa-bank/site-util-create-widget/src/models';
import { BigArrowLeftLineMIcon as LinkIcon } from '@alfalab/icons-glyph/BigArrowLeftLineMIcon';
import cn from 'classnames';
import type { FC } from 'react';
import React from 'react';

import { isLastItem } from '../../helpers';

import type { TSubSection } from './models';

export const SubSection: FC<TSubSection> = ({
    SectionLink,
    analytics,
    className,
    styles,
    subSection,
    withIcons,
}) => {
    /** Если детей нет, то отступ снизу убираем */
    const styler: IStyler = {
        marginBottom: subSection.children.length > 0 ? 4 : 0,
    };

    return (
        <div
            className={cn(
                styles.subSection,
                withIcons && styles.withIcons,
                styles.external,
                styles.subSectionTitle,
                className
            )}
        >
            {withIcons && (
                <LinkIcon className={cn(styles.external, styles.bigArrow)} height={16} width={16} />
            )}
            <SectionLink
                analytics={analytics || subSection.analytics}
                href={subSection.link}
                styler={styler}
                type="subSection"
                withIcons={withIcons}
            >
                {subSection.title}
            </SectionLink>
            {subSection.children.length > 0 &&
                subSection.children.map((link, key) => {
                    /** :last-child css like. Нужно, чтоб не было лишних отступов снизу */
                    const stylerLink: IStyler = {
                        marginBottom: isLastItem(subSection.children, key) ? 0 : 4,
                    };

                    return (
                        <SectionLink
                            key={key}
                            analytics={link.analytics}
                            href={link.link}
                            styler={stylerLink}
                            type="sectionLink"
                            withIcons={withIcons}
                        >
                            {link.title}
                        </SectionLink>
                    );
                })}
        </div>
    );
};
